var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0.5C12.8014 0.5 13.0904 0.619724 13.3035 0.832833C13.5166 1.04594 13.6364 1.33498 13.6364 1.63636V11.8636H23.8636C24.165 11.8636 24.4541 11.9834 24.6672 12.1965C24.8803 12.4096 25 12.6986 25 13C25 13.3014 24.8803 13.5904 24.6672 13.8035C24.4541 14.0166 24.165 14.1364 23.8636 14.1364H13.6364V24.3636C13.6364 24.665 13.5166 24.9541 13.3035 25.1672C13.0904 25.3803 12.8014 25.5 12.5 25.5C12.1986 25.5 11.9096 25.3803 11.6965 25.1672C11.4834 24.9541 11.3636 24.665 11.3636 24.3636V14.1364H1.13636C0.834981 14.1364 0.545943 14.0166 0.332833 13.8035C0.119724 13.5904 0 13.3014 0 13C0 12.6986 0.119724 12.4096 0.332833 12.1965C0.545943 11.9834 0.834981 11.8636 1.13636 11.8636H11.3636V1.63636C11.3636 1.33498 11.4834 1.04594 11.6965 0.832833C11.9096 0.619724 12.1986 0.5 12.5 0.5Z",
    fill: "#798CAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGrey);
export default __webpack_public_path__ + "static/media/plusGrey.7c6138cc9247284862e65c0b01d887dd.svg";
export { ForwardRef as ReactComponent };